import i18next from 'i18next';
import { scorEn, scorRu } from 'i18n/scor';

export const getScorLanguage = (): 'en' | 'ru' =>
  (i18next.resolvedLanguage ?? i18next.language ?? 'ru').split('-')[0] === 'en' ? 'en' : 'ru';

export const getScorLocale = (): string => getScorLanguage() === 'en' ? 'en-US' : 'ru-RU';

// Catalog and UI text is localized by the server, including its Russian fallback.
export const scorUiText = (text: string | null | undefined, fallback: keyof typeof scorRu): string =>
  text?.trim() ? text : scorT(fallback);

export const scorMetadataText = (text: string | null | undefined): string | null | undefined => text;

export const scorT = (key: keyof typeof scorRu, values: Record<string, string | number | undefined | null> = {}): string => {
  const fallback = getScorLanguage() === 'en' ? scorEn[key] : scorRu[key];
  if (i18next.isInitialized) return i18next.t(`scor.${key}`, { ...values, defaultValue: fallback, interpolation: { escapeValue: false } });

  return fallback.replace(/\{\{(\w+)\}\}/g, (_, name: string) => String(values[name] ?? ''));
};

export const scorCount = (
  key: 'purchaseMonths' | 'purchaseReports' | 'purchaseExpress' | 'days' | 'includedReports' | 'outcomeReports' | 'invitations' | 'workingDays' | 'outcomeLabel',
  count?: number | null
): string => {
  if (count == null) return '—';
  const category = new Intl.PluralRules(getScorLanguage()).select(count);

  return scorT(`${key}_${category}` as keyof typeof scorRu, { count });
};
